import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { Wordmark } from "./Logo";
import { SITE } from "@/data/site";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 px-4 sm:px-6 pt-4">
      <nav className="mx-auto max-w-7xl flex items-center justify-between rounded-full bg-[#030712]/80 backdrop-blur-xl border border-white/10 pl-5 pr-2 py-2">
        <Link to="/" data-testid="nav-logo" aria-label="Rama Electricals home"><Wordmark /></Link>
        <div className="hidden md:flex items-center gap-1">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) => `relative px-5 py-2 text-sm rounded-full transition-colors duration-300 ${isActive ? "text-[#39FF14]" : "text-slate-300 hover:text-white"}`}>
              {({ isActive }) => (
                <>
                  {isActive && <motion.span layoutId="nav-pill" className="absolute inset-0 rounded-full bg-[#39FF14]/10 border border-[#39FF14]/30" />}
                  <span className="relative">{l.label}</span>
                </>
              )}
            </NavLink>
          ))}
        </div>
        <span className="hidden md:block">
          <a href={`tel:${SITE.phoneRaw}`} data-testid="nav-call-btn" className="btn-neon !py-2.5 !px-5 text-sm">
            <Phone size={15} /> Call now
          </a>
        </span>
        <button className="md:hidden p-3 text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}
            className="md:hidden mx-auto mt-2 max-w-7xl rounded-3xl bg-[#030712]/95 backdrop-blur-xl border border-white/10 p-4 flex flex-col">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} end onClick={() => setOpen(false)} data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) => `font-display text-2xl py-3 px-2 ${isActive ? "text-[#39FF14]" : "text-white"}`}>{l.label}</NavLink>
            ))}
            <a href={`tel:${SITE.phoneRaw}`} className="btn-neon justify-center mt-3" data-testid="mobile-call-btn"><Phone size={16} /> {SITE.phone}</a>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
